import { useCallback, useState } from 'react';

// THE pointer-hover state. onHoverIn never fires on touch, so on a phone
// `hovered` simply stays null. Keyed, because one owner can watch several
// controls: the workout row passes `true`, the logger card passes the hint of
// the control under the pointer. Lifted out of WorkoutRows (#308), its first
// and only caller until the card's hints needed the same signal.
export function useHover<K = true>(): {
  hovered: K | null;
  hoverProps: (key: K) => { onHoverIn: () => void; onHoverOut: () => void };
} {
  const [hovered, setHovered] = useState<K | null>(null);
  const hoverProps = useCallback(
    (key: K) => ({
      onHoverIn: () => setHovered(key),
      // Only the control that set it may clear it: the pointer can enter the
      // next control before the previous one reports leaving.
      onHoverOut: () => setHovered((cur) => (cur === key ? null : cur)),
    }),
    [],
  );
  return { hovered, hoverProps };
}
